export const marketingContentData = {
  howItWorks: [
    {
      title: "1. Get invited to join.",
      description:
        "Participants are alumni, cultural workers, or leaders of organizations in our vetted network.",
    },
    {
      title: "2. Match with an aligned cohort of supportive peers.",
      description:
        "Each participant is placed in a curated group with up to seven other participants. Cohorts are determined by career stage, identity-based affinities, location, alumni status, and more.",
    },
    {
      title: "3. Bond with your cohort during virtual peer-coaching roundtables.",
      description:
        "Once a week, participants join other members of their cohort via secure video calls on Pollinator's artist-designed platform. Roundtable-style conversations are guided by prompts that aim to build group trust, collaborative relationships, and creative momentum.",
    },
    {
      title: "4. Make real connections, and real progress.",
      description:
        "After our 2025 pilot, nine out of ten participants said our program helped expand and deepen their network. Many shared other ways the experience benefited them—including creative breakthroughs, new collaborative projects, invitations to solo exhibitions, and more.",
    },
  ],
  praise: [
    {
      title:
        '"As an organization that\'s been gathering artists and technologists across borders for over a decade, Pollinator can finally help us to connect people in small groups at scale on an international level."',
      description: "—Mechu Rapela, Tenthaus Oslo",
    },
    {
      title:
        '"The world doesn\'t need another big tech platform; it needs [connective technologies] that are fluid, alive, and relational. Pollinator fosters interconnection, cross-pollination, and shared growth—all of which are deeply necessary right now."',
      description: "—Martin Pettis, YMCA",
    },
    {
      title:
        '"Pollinator is another example of what Caroline Woolard has been doing for the last fifteen years: finding ways to connect people in the arts so that they can support one another. She is persistent in her dedication and vision."',
      description:
        "—Samuel Hoi, former president of Otis College of Art and Design and Maryland Institute College of Art",
    },
    {
      title:
        '"I was surprised that my group was made up of all educators and parents. I was refreshed at how quickly (after just a bit of awkwardness) we could dive in and share and truly listen."',
      description: "— Pollinator Pilot Participant",
    },
    {
      title:
        '"The magic of being heard—of my practice being reflected back and the expansion offered by seeing my work through someone else\'s experience—was transformational."',
      description: "— Pollinator Pilot Participant",
    },
    {
      title:
        '"We all came into the program with the mindset of, \'How can this help boost my career?\' But as the program went on, it became really evident that this was not a transactional situation. It became more about, \'How do we support each other, and how do we give to each other?\'"',
      description: "— Pollinator Pilot Participant",
    },
  ],
  team: [
    {
      title: "Program Design",
      subheader: "Caroline Woolard\nOr Zubalsky",
      description:
        "Pollinator Co-Directors Caroline Woolard and Or Zubalsky are artists, educators, and technologists who have been collaborating for 15 years. From 2008-2018, they built and maintained TradeSchool.coop, an international peer-to-peer learning platform that was used in 30 cities internationally. Caroline Woolard is the Head of Foundations at Montclair State University, is the co-founder of Art.coop, a national network of art and design cooperatives, and is the co-author of Making and Being, a book about collaborative pedagogy. Or Zubalsky is a 2025 Jerome Hill Artist Fellow, and was previously a resident at Pioneer Works, a NEW INC incubator member, and C/Change R&D Lab fellow. Zubalsky and Woolard have taught for over a decade at The New School, Rhode Island School of Design, Cooper Union, the School of Visual Arts, the University of New Mexico, Bennington College, George Washington University, and the University of Hartford. Learn more about [Zubalsky](https://orzubalsky.com/) and [Woolard](https://carolinewoolard.com/) here.",
    },
    {
      title: "Engineering",
      subheader: "Minima.nyc",
      description:
        "Zubalsky and Woolard got together to build Pollinator with a team of aligned engineers in 2024. The team at Minima has worked together since 2014 to deliver cutting-edge software-based solutions for corporate clients. Minima has built and managed widely used web, mobile, and server-side applications, including the entirety of Apple's Music TV. Minima builds complex systems that scale, are maintainable, and cost effective. Minima prioritizes the end user across axes of accessibility, security, communication, and simplicity.",
    },
    {
      title: "Creative Director",
      description: "Caroline Woolard",
    },
    {
      title: "Creative Operations",
      description: "Or Zubalsky",
    },
    {
      title: "Outreach + Operations",
      description: "Isaiah Madison",
    },
    {
      title: "Branding",
      description: "Topos Graphics",
    },
    {
      title: "Design",
      description: "Or Zubalsky",
    },
    {
      title: "Copywriting",
      description: "Willa Köerner",
    },
    {
      title: "Pedagogy",
      description: "Caroline Woolard\n\nBelén Santillán",
    },
    {
      title: "Repair",
      description: "Martin Pettis",
    },
    {
      title: "Special Projects",
      description: "Mechu Rapela\n\nShahrzad Malekian\n\nIda Uvaas",
    },
  ],
  advisors: [
    {
      title: "Oihane Amurrio",
      description: "Lead Program Developer, Mondragon Team Academy",
    },
    {
      title: "Ted Berger",
      description:
        "Executive Director Emeritus of the New York Foundation for the Arts",
    },
    {
      title: "Sarah Calderon",
      description: "Founding Executive Director, Creatives Rebuild New York",
    },
    {
      title: "Pablo Helguera",
      description: "Artist + Educator",
    },
    {
      title: "Sophie Landres",
      description: "Curator",
    },
    {
      title: "Ruby Lerner",
      description: "Founding Director, Creative Capital",
    },
    {
      title: "Sofía Olascoaga",
      description: "Curator + Educator",
    },
    {
      title: "Martin Pettis",
      description: "Executive Director, WE CARE Therapies",
    },
    {
      title: "Nathan Schneider",
      description: "University of Colorado",
    },
    {
      title: "Jean Shin",
      description: "Artist + Educator",
    },
    {
      title: "Gesyada Annisa Namora Siregar",
      description: "Curator",
    },
    {
      title: "Wendy Woon",
      description:
        "Artist, former Edward John Noble Deputy Director for Education, MoMA",
    },
  ],
};

export default marketingContentData;
